export default __webpack_public_path__ + "static/media/icon-birthday-cycle.28a593de.svg";